module.exports = __webpack_public_path__ + "media/images/cover/bathroom-1-c632a28da5f11af8d1fd0e676c3366fa.jpeg";